module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image17.34b3b2e0.webp";